
import { defineComponent } from 'vue';
import authStore from '@/firebase/auth';
import {
  getStripeCustomerSubscription,
  getSubscriptionPrice,
  getSubscriptionQuantity
} from '@/stripe/stripeSubscription';
import Stripe from 'stripe';
export default defineComponent({
  name: 'CurrentProductInfo',
  async setup() {
    if (!authStore.stripeId)
      return {
        userSubscription: undefined
      };
    const userSubscription = await getStripeCustomerSubscription(
      authStore.stripeId
    );
    return {
      userSubscription: userSubscription
    };
  },
  async mounted() {
    if (!authStore.stripeId)
      return {
        userSubscription: undefined
      };
    const userSubscription = await getStripeCustomerSubscription(
      authStore.stripeId
    );
    return {
      userSubscription: userSubscription
    };
  },
  methods: {
    getPricePer() {
      if (!this.userSubscription) return 'Free';
      return `$${getSubscriptionPrice(this.userSubscription)}/${
        this.userSubscription.items.data[0].plan.interval
      }`;
    },
    getProductName() {
      if (!this.userSubscription) {
        return 'Free trial';
      }
      return 'Subscription';
    },
    getSubscriptionQuantity(subscription: Stripe.Subscription) {
      return getSubscriptionQuantity(subscription);
    }
  }
});
